var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAwardStandardsPlano(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "61.825409mm",
    height: "61.825409mm",
    viewBox: "0 0 61.825409 61.825409",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-65.222666,-79.416199)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4795",
    transform: "translate(0.3865491)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 2.95642,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path43",
    cx: 95.458397,
    cy: 97.597519,
    r: 16.70311
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect1512",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 2.89999,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 92.308735,114.45472 3.491269,8.80527 -7.864109,16.53186 -4.450368,-12.64668 -13.287729,3.18338 12.126801,-22.177 c 0.953123,1.74688 7.779059,6.28574 9.984136,6.30317 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect1512-3",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 2.89999,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 108.11125,108.39663 13.18862,23.57992 -13.6761,-4.55899 -4.97517,12.06395 -10.339865,-25.02679 c 7.786875,-0.96043 9.541055,-0.2768 15.802515,-6.05809 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwardStandardsPlano);
export default __webpack_public_path__ + "static/media/award_standards_plano.47f01fa5752dbab4bc4675191afd4855.svg";
export { ForwardRef as ReactComponent };